import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { decision } = commonConfigValues

const { helpers: { keepInLength, getLoginFromMail, getUserId } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'personnel.ui',
      'personnel.fullName',
      'centre.centreName',
      'contract.type',
      'contract.hours',
      'contract.averageHours',
      'role.roleType',
      'role.role',
      'employment.status'
    ]
  }
]

export const defaultSorting = [
  { columnName: 'personnel.name', direction: 'asc' }
]

export const roleType = [
  { id: 1, label: 'Administration' },
  { id: 2, label: 'Clinical' },
  { id: 3, label: 'Domestic' },
  { id: 4, label: 'Maintenance' },
  { id: 5, label: 'Centre Management' },
  { id: 6, label: 'Centre Management on Roster' },
  { id: 7, label: 'Senior / Service Management' },
  { id: 8, label: 'Staff on Roster' },
  { id: 9, label: 'Other' }
]

export const contractType = [
  { id: 1, label: 'Agency Worker - Ad Hoc' },
  { id: 2, label: 'Agency Worker - Contracted' },
  { id: 3, label: 'Employed - Fixed-Term Contract' },
  { id: 4, label: 'Employed - Permanent Contract' },
  { id: 5, label: 'Employed - Temporary Contract' },
  { id: 6, label: 'Independent Contractor' },
  { id: 7, label: 'Other' }
]

export const employmentStatus = [
  { id: 1, label: 'Active' },
  { id: 2, label: 'Active - Maternity Leave Pending' },
  { id: 3, label: 'Active - Resignation Pending' },
  { id: 4, label: 'Inactive Temp - Long Term Sick Leave' },
  { id: 5, label: 'Inactive Temp - Maternity Leave' },
  { id: 6, label: 'Inactive - Resigned' },
  { id: 7, label: 'Inactive - Retired' },
  { id: 8, label: 'Other' }
]

export const valueTable = {
  employmentStatus,
  contractType,
  roleType
}

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.ui',
    title: 'Staff Member Personel No. (UI)',
    minSpace: 'Personel No. (UI) ',
    formField: true
  },
  {
    name: 'register.firstName',
    title: 'SM First Name',
    hidden: true,
    minSpace: 'SM ',
    formField: true
  },
  {
    name: 'register.lastName',
    title: 'SM Last Name',
    hidden: true,
    minSpace: 'SM ',
    formField: true
  },
  {
    name: 'register.fullName',
    title: 'Staff Member Name',
    formField: true,
    getCellValue: row =>
      `${row['register.firstName'] || ''} ${row['register.lastName'] || ''}`,
    maxChars: 100,
    minSpace: 'Staff Member '
  },
  {
    name: 'company.startDate',
    title: 'Company Start Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Company Start '
  },
  {
    name: 'company.interviewDate',
    title: 'Interview Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Interview Date '
  },
  {
    name: 'company.descriptionOnFile',
    title: 'Job Description on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`company.descriptionOnFile`], 10)])
        ? _.find(decision, [
            'id',
            parseInt(row[`company.descriptionOnFile`], 10)
          ]).label
        : row[`company.descriptionOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Job Description '
  },
  {
    name: 'company.applicationOnFile',
    title: 'Job Application on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`company.applicationOnFile`], 10)])
        ? _.find(decision, [
            'id',
            parseInt(row[`company.applicationOnFile`], 10)
          ]).label
        : row[`company.applicationOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Job Application '
  },
  {
    name: 'company.interviewOnFile',
    title: 'Interview Notes on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`company.interviewOnFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`company.interviewOnFile`], 10)])
            .label
        : row[`company.interviewOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Interview Notes '
  },
  {
    name: 'company.offerOnFile',
    title: 'Job Offer on File?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`company.offerOnFile`], 10)])
        ? _.find(decision, ['id', parseInt(row[`company.offerOnFile`], 10)])
            .label
        : row[`company.offerOnFile`],
    options: 'decision',
    filterField: true,
    minSpace: 'Job Offer on '
  },
  {
    name: 'company.exitDate',
    title: 'Company Exit Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Company Exit '
  },

  {
    name: 'centre.centreName',
    title: 'Assigned to Centre Name(s)',
    formField: true,
    type: 'select',
    // getCellValue: row =>
    //   _.find(centres, ['id', parseInt(row[`centre.centreName`], 10)])
    //     ? _.find(centres, ['id', parseInt(row[`centre.centreName`], 10)]).label
    //     : row[`centre.centreName`],
    options: 'centres',
    filterField: true,
    minSpace: 'Assigned to Centre Name(s) '
  },
  {
    name: 'centre.date',
    title: 'Assigned to Centre Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Assigned to  '
  },
  {
    name: 'contract.type',
    title: 'Contract Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(contractType, ['id', parseInt(row[`contract.type`], 10)])
        ? _.find(contractType, ['id', parseInt(row[`contract.type`], 10)]).label
        : row[`contract.type`],
    options: 'contractType',
    filterField: true,
    minSpace: 'Contract Type '
  },
  {
    name: 'contract.hours',
    title: 'Contracted Hours ',
    formField: true,
    // filterField: true,
    minSpace: 'Contracted '
  },
  {
    name: 'contract.averageHours',
    title: 'Average / Hours Currently Worked ',
    formField: true,
    // filterField: true,
    minSpace: 'Average / Hours Curr '
  },
  {
    name: 'role.type',
    title: 'Role Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(roleType, ['id', parseInt(row[`role.type`], 10)])
        ? _.find(roleType, ['id', parseInt(row[`role.type`], 10)]).label
        : row[`role.type`],
    options: 'roleType',
    filterField: true,
    minSpace: 'Role Type '
  },

  {
    name: 'role.role',
    title: 'Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(employmentStatus, ['id', parseInt(row[`role.role`], 10)])
        ? _.find(employmentStatus, ['id', parseInt(row[`role.role`], 10)]).label
        : row[`role.role`],
    options: 'employmentStatus',
    filterField: true,
    minSpace: 'Role '
  },
  {
    name: 'role.applicableDate',
    title: 'Role Applicable Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Role Applicable '
  },
  {
    name: 'employment.status',
    title: 'Employment Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(employmentStatus, ['id', parseInt(row[`employment.status`], 10)])
        ? _.find(employmentStatus, [
            'id',
            parseInt(row[`employment.status`], 10)
          ]).label
        : row[`employment.status`],
    options: 'employmentStatus',
    filterField: true,
    minSpace: 'Employment Status Chan '
  },
  {
    name: 'employment.changeDate',
    title: 'Employment Status Change Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Status Change '
  },
  {
    name: 'employment.notes',
    title: 'Employment Notes',
    formField: true,
    maxChars: 500,
    // filterField: true,
    minSpace: 'Employment Notes '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues,
  activeFormName
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'role',
      historyName: 'roleHistory',
      disabled: activeFormName !== 'reg',
      label: 'Personnel',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Personnel Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'com',
      activeName: 'company',
      historyName: 'companyHistory',
      disabled: activeFormName !== 'com',
      label: 'Company',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'company.startDate',
            label: 'Company Start Date',
            disabled: !add && (disabled || activeFormName !== 'com'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'com' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'company.interviewDate',
            label: 'Interview Date',
            disabled: !add && (disabled || activeFormName !== 'com'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'com' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'company.descriptionOnFile',
            label: 'Job Description on File?',
            disabled: !add && (disabled || activeFormName !== 'com'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'com' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'company.applicationOnFile',
            label: 'Job Application on File? ',
            disabled: !add && (disabled || activeFormName !== 'com'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'com' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'company.interviewOnFile',
            label: 'Interview Notes on File? ',
            disabled: !add && (disabled || activeFormName !== 'com'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'com' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'company.offerOnFile',
            label: 'Job Offer on File? ',
            disabled: !add && (disabled || activeFormName !== 'com'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'com' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'company.exitDate',
            label: 'Company Exit Date ',
            disabled: !add && (disabled || activeFormName !== 'com'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'com' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'company.exitOnFile',
            label: 'Exit Interview on File? ',
            disabled: !add && (disabled || activeFormName !== 'com'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'com' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ]
      ]
    },
    {
      id: 3,
      name: 'cen',
      activeName: 'centre',
      historyName: 'centreHistory',
      disabled: activeFormName !== 'cen',
      label: 'Centre',
      icon: 'note',
      fields: [
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'centre.centreName',
            // disabled: !add,
            label: 'Assigned to Centre Name(s)',
            disabled: !add && (disabled || activeFormName !== 'cen'),
            required: showAsterix,
            validate: v =>
              activeFormName !== 'cen' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.centres.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.name }
            })
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'centre.date',
            label: 'Assigned to Centre Date',
            disabled: !add && (disabled || activeFormName !== 'cen'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'cen' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ]
      ]
    },
    {
      id: 4,
      name: 'con',
      activeName: 'contract',
      historyName: 'contractHistory',
      disabled: activeFormName !== 'con',
      label: 'Contract',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'contract.type',
          label: 'Contract Type',
          disabled: !add && (disabled || activeFormName !== 'con'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'con' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: availableValues.contractType.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          name: 'contract.hours',
          label: 'Contracted Hours',
          disabled: !add && (disabled || activeFormName !== 'con'),
          normalize: v => {
            const val = keepInLength(v, 5) //normalize to numeric
            return val
          },
          validate: v =>
            activeFormName !== 'con' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          name: 'contract.averageHours',
          label: 'Average / Hours Currently Worked',
          disabled: !add && (disabled || activeFormName !== 'con'),
          normalize: v => {
            const val = keepInLength(v, 5) //normalize to numeric
            return val
          },
          validate: v =>
            activeFormName !== 'con' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'contract.reason',
          label: 'Reason for Reduced Hours (I/A)',
          disabled: !add && (disabled || activeFormName !== 'con'),
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v =>
            activeFormName !== 'con' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        }
      ]
    },
    {
      id: 5,
      name: 'rol',
      activeName: 'role',
      historyName: 'roleHistory',
      disabled: activeFormName !== 'rol',
      label: 'Role',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'role.type',
          label: 'Role Type',
          disabled: !add && (disabled || activeFormName !== 'rol'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'rol' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: availableValues.roleType.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'role.role',
          label: 'Role',
          disabled: !add && (disabled || activeFormName !== 'rol'),
          required: showAsterix,
          validate: v =>
            activeFormName !== 'rol' && !add
              ? undefined
              : v ? undefined : 'Field is required',
          options: availableValues.employmentStatus
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },

        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'role.applicableDate',
          label: 'Role Applicable Date',
          disabled: !add && (disabled || activeFormName !== 'rol'),
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v =>
            activeFormName !== 'rol' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        }
      ]
    },
    {
      id: 6,
      name: 'emp',
      activeName: 'employment',
      historyName: 'employmentHistory',
      disabled: activeFormName !== 'emp',
      label: 'Employment',
      icon: 'note',
      fields: [
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'employment.status',
            label: 'Employment Status',
            disabled: !add && (disabled || activeFormName !== 'emp'),
            required: showAsterix,
            options: availableValues.employmentStatus
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.label, label: o.label }
              }),
            validate: v =>
              activeFormName !== 'emp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'employment.changeDate',
            label: 'Employment Status Change Date',
            disabled: !add && (disabled || activeFormName !== 'emp'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'emp' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'employment.notes',
          label: 'Employment Notes',
          disabled: !add && (disabled || activeFormName !== 'emp'),
          normalize: v => {
            const val = keepInLength(v, 500)
            return val
          }
          // validate: v =>
          // activeFormName !== 'emp' && !add
          //   ? undefined
          //   : v ? undefined : 'Field is required'
        }
      ]
    }
  ]

  return forms
}

export const activeSection = [
  'company',
  'centre',
  'contract',
  'role',
  'employment'
]

export const errors = [1, 2]

export const defaultNew = {
  role: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  company: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  centre: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  contract: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  employment: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  centreHistory: [],
  employmentHistory: [],
  contractHistory: [],
  companyHistory: [],
  roleHistory: []
}

// "roles": [
//   {
//   "id": 1,
//   "registerId": 1,
// "company": {
//   "startDate": "2001-01-01T23:28:56.782Z",
//   "interviewDate": "2001-01-01T23:28:56.782Z",
//   "descriptionOnFile": 1,
//   "applicationOnFile": 1,
//   "interviewOnFile": 1,
//   "offerOnFile": 1,
//   "exitOnFile": 1
// },
// "centre":{
//   "centreName":1,
//   "date":"2001-01-01T23:28:56.782Z"
// },
// "contract":{
//   "type": 1,
//   "hours": "22",
//   "averageHours": 21,
//   "reason":"some reason",

// },
// "role": {
//   "type":1,
//   "role":1,
//   "applicableDate": "2001-01-01T23:28:56.782Z"

// },
// "employment": {
// "status" : 1,
// "changeDate" : "2001-01-01T23:28:56.782Z",
// "notes": "dadad"
// },
// "centreHistory": [],
// "contractHistory": [],
// "companyHistory": [],
// "roleHistory": [],
// "employmentHistory": [],
// ]



// WEBPACK FOOTER //
// ./src/personnel/configs/roles.js